<template>
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-card-title :style="styleObject">
        <v-row>
          <v-col cols="11">
            <v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }}
          </v-col>
          <v-col cols="1">
            <v-btn dark text color="blue" @click="dialogframeboton = false"
              >Cerrar</v-btn
            >
          </v-col>
          <v-col cols="12">
            <h6>
              {{ infocolumna.Columna[2].VC[1] }} ♦
              {{ infocolumna.Columna[2].VR[0] }} ♦
              {{ infocolumna.Columna[1].VC[2] }} ♦
              {{ infocolumna.Columna[1].VR[6] }} ♦
              {{ infocolumna.Columna[1].VR[5] }}
              <br />
              {{ infocolumna.Columna[1].VC[3] }} ♦
              {{ infocolumna.Columna[1].VR[22] }} ♦
              {{ infocolumna.Columna[1].VR[17] }} ♦
              {{ infocolumna.Columna[1].VR[18] }} ♦
              {{
                infocolumna.Columna[1].VR[13] != "" &&
                infocolumna.Columna[1].VR[13] != null
                  ? " ♦ " + infocolumna.Columna[1].VR[13]
                  : ""
              }}
              ♦ {{ infocolumna.Columna[1].VR[9] }} ♦
              {{ infocolumna.Columna[1].VR[10] }} ♦
              {{ infocolumna.Columna[1].VR[11] }}
              {{ infocolumna.Columna[1].VR[12] }}
              <br />
              {{ infocolumna.Columna[1].VR[19] }}
              {{
                infocolumna.Columna[1].VR[20] != "" &&
                infocolumna.Columna[1].VR[20] != null
                  ? " ♦ " + infocolumna.Columna[1].VR[20]
                  : ""
              }}
              {{
                infocolumna.Columna[1].VR[21] != "" &&
                infocolumna.Columna[1].VR[21] != null
                  ? " ♦ " + infocolumna.Columna[1].VR[21]
                  : ""
              }}
            </h6>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <!-- Consulta Riesgos ¡-->
        <card-riesgos
          v-if="componenteview == 0"
          :typedocument="llaves.TypeDocument_ID"
          :document="llaves.Document_ID"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[0].ParametrosTablero"
        ></card-riesgos>
        <!-- Consulta Contratos ¡-->
        <card-contratos
          v-else-if="componenteview == 1"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[1].ParametrosTablero"
        ></card-contratos>
        <!-- Consulta Activos ¡-->
        <card-activos
          v-else-if="componenteview == 2"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[2].ParametrosTablero"
        ></card-activos>
        <!-- Consulta  Seguros ¡-->
        <card-seguros
          v-else-if="componenteview == 3"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[3].ParametrosTablero"
          :paramiframeuno="param1"
        ></card-seguros>
        <!-- Ubicación ¡-->
        <card-direcciones
          v-else-if="componenteview == 4"
          :typedocument="llaves.TypeDocument_ID"
          :document="llaves.Document_ID"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[4].ParametrosTablero"
        ></card-direcciones>
        <!-- Cliente ¡-->
        <card-personas
          v-else-if="componenteview == 5"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[5].ParametrosTablero"
        ></card-personas>
        <!-- Nuevo Contacto ¡-->
        <card-newcontact
          v-else-if="componenteview == 6"
          :typedocument="llaves.TypeDocument_ID"
          :document="llaves.Document_ID"
          :pageiframe="dialogframeboton"
          :infopermisos="'0110'"
        ></card-newcontact>
        <!-- Historico de Soportes ¡-->
        <card-historicos
          v-else-if="componenteview == 7"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="PermisoHistorico"
          :paramiframeuno="param1"
        ></card-historicos>
        <!-- Consulta Documentos ¡-->
        <card-consultadocumentos
          v-else-if="
            componenteview == 8 ||
            componenteview == 9 ||
            componenteview == 10 ||
            componenteview == 11
          "
          :infollaves="llaves"
        ></card-consultadocumentos>
        <!-- Relación Activo Servicio ¡-->
        <card-rsa
          v-else-if="componenteview == 12"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="'0110'"
        ></card-rsa>
        <!-- Consulta  Trazabilidad ¡-->
        <card-trazabilidad
          v-else-if="componenteview == 13"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[3].ParametrosTablero"
        ></card-trazabilidad>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Tablero de control -->
  <v-data-table
    :headers="headers"
    :items="desserts"
    :loading="progreso"
    v-model:page="pageTable"
    v-model:items-per-page="itemsPerPage"
    height="550px"
  >
    <!-- PAGINADOR CUSTOM -->
    <template #bottom>
      <div
        class="d-flex align-center justify-space-between px-4 py-3 w-100 gap-4"
        style="border-top: 1px solid #e0e0e0"
      >
        <!-- Total de registros -->
        <div class="text-grey-darken-1 text-body-2">
          Total: <strong>{{ totalRecords }}</strong> registros
        </div>

        <!-- Paginador + Select en una sola línea -->
        <div class="d-flex align-center gap-4">
          <!-- Select tamaño página -->
          <v-select
            v-model="itemsPerPage"
            :items="[10, 20, 50, 100]"
            density="compact"
            variant="outlined"
            hide-details
            style="max-width: 110px"
            @update:modelValue="loadLazy"
            label="Registros"
          ></v-select>

          <!-- Paginador compacto -->
          <v-pagination
            v-model="page"
            :length="totalPages"
            total-visible="5"
            density="comfortable"
            rounded="circle"
            @update:modelValue="loadLazy"
          ></v-pagination>
        </div>
      </div>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="reset">Limpiar</v-btn>
                <v-btn dark text @click="ValidateCampos">Consultar</v-btn>
                <v-btn dark text @click="dialogframe = false">Cerrar</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="Descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>
                  <!-- Contenido -->
                  <!--Responsable -->
                  <v-col v-if="i == 0" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayUser"
                      :item-title="
                        (ArrayUser) =>
                          ArrayUser.Usuario +
                          '-' +
                          ArrayUser.Nombre +
                          ' ' +
                          ArrayUser.Apellido
                      "
                      item-value="Usuario"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Servicio -->
                  <v-col v-else-if="i == 6" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayServicio"
                      :item-title="
                        (ArrayServicio) =>
                          ArrayServicio.ServicioID +
                          '-' +
                          ArrayServicio.DescripcionServicio
                      "
                      item-value="ServicioID"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Estado del Soporte -->
                  <v-col v-else-if="i == 7" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayEstadoSoporte"
                      :item-title="
                        (ArrayEstadoSoporte) =>
                          ArrayEstadoSoporte.Valor +
                          '-' +
                          ArrayEstadoSoporte.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Tipo de Activo -->
                  <v-col v-else-if="i == 10" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoActivo"
                      :item-title="
                        (ArrayTipoActivo) =>
                          ArrayTipoActivo.ID + '-' + ArrayTipoActivo.Descripcion
                      "
                      item-value="ID"
                      color="primary"
                      label="Tipo de Activo:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :title="
                            item?.raw?.TA_ID + '-' + item?.raw?.Descripcion
                          "
                        ></v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <!--Tipo de Subactivo -->
                  <v-col v-else-if="i == 11" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArraySubTipoActivo"
                      :item-title="
                        (ArraySubTipoActivo) =>
                          ArraySubTipoActivo.ID +
                          '-' +
                          ArraySubTipoActivo.Descripcion
                      "
                      item-value="ID"
                      color="primary"
                      label="Tipo de Subactivo :"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Departamento -->
                  <v-col v-else-if="i == 12" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayDpto_ID"
                      :item-title="
                        (ArrayDpto_ID) =>
                          ArrayDpto_ID.DepartamentoId +
                          '-' +
                          ArrayDpto_ID.Nombre
                      "
                      item-value="DepartamentoId"
                      color="primary"
                      :label="datos.label"
                      :update:modelValue="ChangeDepto_ID()"
                      dense
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Ciudad -->
                  <v-col v-else-if="i == 13" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayCiudad_ID"
                      :item-title="
                        (ArrayCiudad_ID) =>
                          ArrayCiudad_ID.CiudadId + '-' + ArrayCiudad_ID.Nombre
                      "
                      item-value="CiudadId"
                      color="primary"
                      :label="datos.label"
                      dense
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Estado del Contrato -->
                  <v-col v-else-if="i == 14" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayEstadoContrato"
                      :item-title="
                        (ArrayEstadoContrato) =>
                          ArrayEstadoContrato.Valor +
                          '-' +
                          ArrayEstadoContrato.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Estado del contrato:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Novedad del Contrato -->
                  <v-col v-else-if="i == 15" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayNovedadContrato"
                      :item-title="
                        (ArrayNovedadContrato) =>
                          ArrayNovedadContrato.Valor +
                          '-' +
                          ArrayNovedadContrato.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Novedad del contrato:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Estado del Activo -->
                  <v-col v-else-if="i == 16" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayEstadoActivo"
                      :item-title="
                        (ArrayEstadoActivo) =>
                          ArrayEstadoActivo.Valor +
                          '-' +
                          ArrayEstadoActivo.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Estado del Activo:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!-- Indice Validar -->
                  <v-col v-else-if="i == 17" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayIndiceValidar"
                      :item-title="
                        (ArrayIndiceValidar) =>
                          ArrayIndiceValidar.Valor +
                          '-' +
                          ArrayIndiceValidar.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Estado Validación:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Tipo de Servicio Contrato -->
                  <v-col v-else-if="i == 18" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoServicio"
                      :item-title="
                        (ArrayTipoServicio) =>
                          ArrayTipoServicio.Valor +
                          '-' +
                          ArrayTipoServicio.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Tipo de servicio contratado:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :type="i == 8 ? 'date' : ''"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>

        <!-- Buscador
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field> -->
      </v-toolbar>
    </template>
    <!-- Riesgo -->
    <template v-slot:column.riesgo="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="red" v-bind="props">mdi-alert-circle</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- Ubicación/Contrato/Activo -->
    <template v-slot:column.Ubicacion="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="green" v-bind="props">mdi-file-account</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- Persona -->
    <template v-slot:column.persona="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="#33A5FF" v-bind="props">mdi-human-greeting</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- Seguros -->
    <template v-slot:column.Seguros="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="red-darken-2" v-bind="props">mdi-file-lock</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- Soportes -->
    <template v-slot:column.soportes="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="#B6332E" v-bind="props">mdi-folder-search</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- trazabilidad -->
    <template v-slot:column.trazabilidad="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="#1E989C" v-bind="props">mdi-history</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- auditoria -->
    <template v-slot:column.auditoria="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="#2BB7C1" v-bind="props">mdi-chart-pie</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- agendamiento -->
    <template v-slot:column.agendamiento="{ column }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon color="#408F29" v-bind="props">mdi-calendar-clock</v-icon>
        </template>
        <span>{{ column.title }}</span>
      </v-tooltip>
    </template>
    <!-- Registro -->
    <template v-slot:item="{ item }">
      <tr>
        <td v-for="(tactivo, index) in item.raw.Columna" :key="index">
          <!-- Registro Riesgos -->
          <div v-if="index == 0" align="left">
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <v-icon
                  dark
                  @click="Iconos(item.raw, 0)"
                  :color="item.raw.Columna[0].VC[1]"
                  v-bind="props"
                  >{{ item.raw.Columna[0].VC[0] }}</v-icon
                >
              </template>
              <span
                >{{ item.raw.Columna[1].VC[2] }} <br />
                {{ item.raw.Columna[1].VC[3] }} <br />
                {{ item.raw.Columna[0].VR[0] }}
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Contrato -->
          <div v-if="index == 1" align="left">
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <span @click="Iconos(item.raw, 1)" v-bind="props"
                  ><b> {{ item.raw.Contrato_ID }} </b></span
                >
              </template>
              <span
                >{{ item.raw.Columna[1].VC[2] }} <br />
                {{ item.raw.Columna[1].VC[3] }} <br />
                <strong>Estado del Contrato: </strong>
                <i> {{ item.raw.Columna[1].VR[2] }} </i> <br />
                <strong> Novedad del Contrato: </strong>
                <i> {{ item.raw.Columna[1].VR[3] }} </i> <br />
                <strong> Estado del Activo: </strong>
                <i> {{ item.raw.Columna[1].VR[4] }} </i> <br />
                <strong> Tipo del Servicio: </strong>
                <i> {{ item.raw.Columna[1].VR[27] }} </i> <br />
                <strong> Tipo del Servicio Origen: </strong>
                <i> {{ item.raw.Columna[1].VR[28] }} </i> <br />
                <strong> Fecha Recepción: </strong>
                <i> {{ item.raw.Columna[1].VR[29] }} </i> <br />
                <i> {{ item.raw.Columna[1].VR[6] }} </i> <br />
                <i> {{ item.raw.Columna[1].VR[5] }} </i><br />
                <i> {{ item.raw.Columna[1].VR[25] }} </i><br />
                <i> {{ item.raw.Columna[1].VR[26] }} </i>
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Activo -->
          <div v-if="index == 2" align="left">
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  color="red-darken-4"
                  :icon="item.raw.Columna[1].VC[0]"
                  size="x-small"
                ></v-btn>
              </template>
              <span
                >{{ item.raw.Columna[1].VC[2] }} <br />
                {{ item.raw.Columna[1].VC[3] }} <br />
                <strong>Estado del Contrato: </strong>
                <i> {{ item.raw.Columna[1].VR[2] }} </i> <br />
                <strong> Novedad del Contrato: </strong>
                <i> {{ item.raw.Columna[1].VR[3] }} </i> <br />
                <strong> Estado del Activo: </strong>
                <i> {{ item.raw.Columna[1].VR[4] }} </i> <br />
                <i> {{ item.raw.Columna[1].VR[6] }} </i> <br />
                <i> {{ item.raw.Columna[1].VR[5] }} </i>
              </span>
            </v-tooltip>
            <span @click="Iconos(item.raw, 2)">
              {{ " " + item.raw.Columna[1].VC[3] }}
            </span>
          </div>
          <!-- Registro Ubicación-Contacto -->
          <div v-if="index == 3" align="left">
            <!-- Registro Ubicación -->
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 4)"
                  color="#0D9DA9"
                  v-bind="props"
                  >{{ item.raw.Columna[1].VC[1] }}</v-icon
                >
              </template>
              <span
                ><strong>
                  {{ item.raw.Columna[1].VC[2] + " " }}
                </strong>
                <strong>{{ item.raw.Columna[1].VC[3] }} </strong> <br />
                <i> {{ item.raw.Columna[1].VR[7] }} </i> <br />
                <i> {{ item.raw.Columna[1].VR[8] }} </i> <br />
                <i> {{ item.raw.Columna[1].VR[9] }} </i> <br />
                <i> {{ item.raw.Columna[1].VR[10] }} </i> <br />
                <span
                  v-if="
                    item.raw.Columna[1].VR[11] != '' &&
                    item.raw.Columna[1].VR[11] != null
                  "
                >
                  <i> {{ item.raw.Columna[1].VR[11] }} </i> <br />
                </span>
                <span
                  v-if="
                    item.raw.Columna[1].VR[12] != '' &&
                    item.raw.Columna[1].VR[12] != null
                  "
                >
                  <i> {{ item.raw.Columna[1].VR[12] }} </i> <br
                /></span>
                <span
                  v-if="
                    item.raw.Columna[1].VR[13] != '' &&
                    item.raw.Columna[1].VR[13] != null
                  "
                >
                  <i> {{ item.raw.Columna[1].VR[13] }} </i> <br />
                </span>
                <v-icon color="black">{{ item.raw.Columna[1].VR[14] }}</v-icon>
                <i> {{ item.raw.Columna[1].VR[15] }} </i> <br />
                <i>
                  {{ item.raw.Columna[1].VR[16] + " - " }}
                  {{ item.raw.Columna[1].VR[17] }}
                </i></span
              >
            </v-tooltip>
            <!-- Registro Nuevo Contacto -->
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 6)"
                  color="orange"
                  v-bind="props"
                  >{{ item.raw.Columna[1].VR[22] }}</v-icon
                >
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}
                  <br />
                  {{ item.raw.Columna[2].VR[0] }} </b
                ><br />
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[2]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[1] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[4]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[3] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[6]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[5] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[8]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[7] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[9]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[10] }}</v-icon
                >
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Persona -->
          <div v-if="index == 4" align="center">
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <span @click="Iconos(item.raw, 5)" v-bind="props">{{
                  item.raw.Columna[2].VC[1]
                }}</span>
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}
                  <br />
                  {{ item.raw.Columna[2].VR[0] }} </b
                ><br />
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[2]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[1] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[4]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[3] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[6]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[5] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[8]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[7] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[9]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[10] }}</v-icon
                >
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Seguros -->
          <div v-if="index == 5" align="center">
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <v-icon @click="Iconos(item.raw, 3)" v-bind="props">{{
                  item.raw.Columna[9].VC[0]
                }}</v-icon>
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }} </b
                ><br />
                {{ item.raw.Columna[9].VR[0] }}
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Documentos -->
          <div v-if="index == 6" align="center">
            <!-- Registro Documentos Clientes -->
            <v-tooltip
              v-if="
                MPermisosFolderDocumentos.length > 0 &&
                MPermisosFolderDocumentos[0] == '1'
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 8)"
                  size="x-large"
                  color="deep-orange"
                  v-bind="props"
                  >{{ item.raw.Columna[3].VC[0] }}</v-icon
                >
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />{{ item.raw.Columna[3].VR[0] }}
              </span>
            </v-tooltip>
            <!-- Registro Documentos Contratos-->
            <v-tooltip
              v-if="
                MPermisosFolderDocumentos.length > 0 &&
                MPermisosFolderDocumentos[1] == '1'
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 9)"
                  size="large"
                  color="#33D1FF"
                  v-bind="props"
                  >{{ item.raw.Columna[3].VC[1] }}</v-icon
                >
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />{{ item.raw.Columna[3].VR[1] }}
              </span>
            </v-tooltip>
            <!-- Registro Documentos Activos -->
            <v-tooltip
              v-if="
                MPermisosFolderDocumentos.length > 0 &&
                MPermisosFolderDocumentos[2] == '1'
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 10)"
                  color="#6032DA"
                  v-bind="props"
                  >{{ item.raw.Columna[3].VC[2] }}</v-icon
                >
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />{{ item.raw.Columna[3].VR[2] }}
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Trazabilidad -->
          <v-tooltip v-if="index == 7" location="bottom" color="white">
            <template v-slot:activator="{ props }">
              <v-icon
                @click="Iconos(item.raw, 13)"
                color="#2F6AE8"
                v-bind="props"
                >{{ item.raw.Columna[4].VC[0] }}</v-icon
              >
            </template>
            <span
              ><b
                >{{ item.raw.Columna[1].VC[2] }}
                {{ item.raw.Columna[1].VC[3] }}</b
              ><br />{{ item.raw.Columna[4].VR[0] }}<br />
              <v-icon
                size="x-large"
                :color="item.raw.Columna[2].VR[2]"
                v-bind="props"
                >{{ item.raw.Columna[2].VR[1] }}</v-icon
              >
              <v-icon
                size="x-large"
                :color="item.raw.Columna[2].VR[4]"
                v-bind="props"
                >{{ item.raw.Columna[2].VR[3] }}</v-icon
              >
              <v-icon
                size="x-large"
                :color="item.raw.Columna[2].VR[6]"
                v-bind="props"
                >{{ item.raw.Columna[2].VR[5] }}</v-icon
              >
              <v-icon
                size="x-large"
                :color="item.raw.Columna[2].VR[8]"
                v-bind="props"
                >{{ item.raw.Columna[2].VR[7] }}</v-icon
              >
              <v-icon
                size="x-large"
                :color="item.raw.Columna[2].VR[9]"
                v-bind="props"
                >{{ item.raw.Columna[2].VR[10] }}</v-icon
              >
            </span>
          </v-tooltip>
          <!-- Registro Agendamiento -->
          <div v-if="index == 8">
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <v-icon color="#3391B4" v-bind="props">{{
                  item.raw.Columna[5].VC[0]
                }}</v-icon>
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />{{ item.raw.Columna[5].VR[0] }}
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Auditoría -->
          <div v-if="index == 9">
            <v-tooltip location="bottom" color="white">
              <template v-slot:activator="{ props }">
                <v-icon color="#2F6AE8" v-bind="props">{{
                  item.raw.Columna[6].VC[0]
                }}</v-icon>
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />{{ item.raw.Columna[6].VR[0] }}
              </span>
            </v-tooltip>
          </div>
          <!-- Registro Servicios -->
          <div v-if="index > 9">
            <!-- Resposable -->
            <v-tooltip
              v-if="
                item.raw.Columna[index].VC[1] != '' &&
                item.raw.Columna[index].VC[1] != null
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-avatar
                  v-if="
                    item.raw.Columna[index].VR[1] != '' &&
                    item.raw.Columna[index].VR[1] != null
                  "
                  size="x-small"
                  :color="item.raw.Columna[index].VR[10]"
                  v-bind="props"
                >
                  <span class="text-h10">{{
                    item.raw.Columna[index].VR[1]
                  }}</span>
                </v-avatar>
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />
                {{ item.raw.Columna[index].VR[0] }}
                <br />
                <i> Estado Validado: {{ item.raw.Columna[index].VR[11] }} </i>
                <br />
                <v-img
                  :src="
                    '/static/img/avatartci/' + item.raw.Columna[index].VC[3]
                  "
                  width="100"
                  height="100"
                ></v-img>
              </span>
            </v-tooltip>
            <!-- Estado -->
            <v-tooltip
              v-if="
                item.raw.Columna[index].VC[1] != '' &&
                item.raw.Columna[index].VC[1] != null
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  @click="Iconos(item.raw, 7, index)"
                  :color="item.raw.Columna[index].VC[2]"
                  :icon="item.raw.Columna[index].VC[1]"
                  size="x-small"
                ></v-btn>
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />
                <i> {{ item.raw.Columna[index].VR[3] }} </i> <br />
                <i> Fecha mora: {{ item.raw.Columna[index].VR[4] }} </i>
                <br />
                <i> Días mora actual: {{ item.raw.Columna[index].VR[6] }} </i>
                <br />
                <i> Dias mora: {{ item.raw.Columna[index].VR[5] }} </i>
                <br />
                <i> Valor Factura: {{ item.raw.Columna[index].VR[13] }} </i>
                <br />
                <i> Valor Descuento: {{ item.raw.Columna[index].VR[14] }} </i>
                <br />
                <i>
                  Fecha Corte Soporte: {{ item.raw.Columna[index].VR[12] }}
                </i>
              </span>
            </v-tooltip>
            <!-- ARS -->
            <v-tooltip
              v-if="
                item.raw.Columna[index].VC[1] != '' &&
                item.raw.Columna[index].VC[1] != null
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 12, index)"
                  color="#F39326"
                  size="small"
                  v-bind="props"
                  >{{ item.raw.Columna[index].VC[4] }}</v-icon
                >
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />
                <i> {{ item.raw.Columna[index].VR[3] }} </i> <br />
                <i>
                  {{ item.raw.Columna[index].VR[7] }} -
                  {{ item.raw.Columna[index].VR[8] }}</i
                >
              </span>
            </v-tooltip>
            <!-- Documemtos por servicio -->
            <v-tooltip
              v-if="
                item.raw.Columna[index].VC[1] != '' &&
                item.raw.Columna[index].VC[1] != null &&
                MPermisosFolderDocumentos.length > 0 &&
                MPermisosFolderDocumentos[3] == '1'
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 11, index)"
                  size="small"
                  color="green darken-3"
                  v-bind="props"
                  >{{ item.raw.Columna[index].VC[5] }}</v-icon
                >
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />
                <i>
                  Documentos Servicios {{ item.raw.Columna[index].VC[6] }}
                </i>
              </span>
            </v-tooltip>
            <!-- Trazabilidad por servicio -->
            <v-tooltip
              v-if="
                item.raw.Columna[index].VC[1] != '' &&
                item.raw.Columna[index].VC[1] != null
              "
              location="bottom"
              color="white"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  @click="Iconos(item.raw, 13, index)"
                  color="#2F6AE8"
                  size="small"
                  v-bind="props"
                  >{{ item.raw.Columna[4].VC[0] }}</v-icon
                >
              </template>
              <span
                ><b
                  >{{ item.raw.Columna[1].VC[2] }}
                  {{ item.raw.Columna[1].VC[3] }}</b
                ><br />{{ item.raw.Columna[4].VR[0] }}<br />
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[2]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[1] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[4]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[3] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[6]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[5] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[8]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[7] }}</v-icon
                >
                <v-icon
                  size="x-large"
                  :color="item.raw.Columna[2].VR[9]"
                  v-bind="props"
                  >{{ item.raw.Columna[2].VR[10] }}</v-icon
                >
              </span>
            </v-tooltip>
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Contratos from "@/views/TCI/ActivosO/Contratos/Contratos.vue";
import Activos from "@/views/TCI/ActivosO/Activos/Activos.vue";
import Seguros from "@/views/TCI/ActivosO/Seguros/Seguros.vue";
import Personas from "@/views/TCI/Personas/Clientes/Clientes.vue";
import Direcciones from "@/views/TCI/Personas/Direcciones/Direcciones.vue";
import NuevoContacto from "@/views/TCI/Personas/NuevoContacto/NuevoContacto.vue";
import Riesgos from "@/views/TCI/Personas/Riesgos/Riesgos.vue";
import R_ServicioAdmin_Activo from "@/views/TCI/ActivosO/R_ServicioAdmin_Activo/R_ServicioAdmin_Activo.vue";
import Historicos from "@/views/TCI/ActivosO/HistoricoSoportes/HistoricoSoportes.vue";
import ConsultaDocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/ConsultaDocumentos.vue";
import Trazabilidad from "@/views/TCI/Personas/Trazabilidad/Trazabilidad.vue";
export default {
  name: "control-activos",
  components: {
    "card-activos": Activos,
    "card-rsa": R_ServicioAdmin_Activo,
    "card-contratos": Contratos,
    "card-seguros": Seguros,
    "card-personas": Personas,
    "card-direcciones": Direcciones,
    "card-newcontact": NuevoContacto,
    "card-riesgos": Riesgos,
    "card-historicos": Historicos,
    "card-consultadocumentos": ConsultaDocumentos,
    "card-trazabilidad": Trazabilidad,
  },
  data() {
    return {
      items: [],
      page: 1,
      pageTable: 1,
      itemsPerPage: 10,
      totalRecords: 0,
      totalPages: 0,
      styleObject: { border: "5px solid #B6332E" },
      search: "",
      progreso: false,
      dialogframe: false,
      dialogframeboton: false,
      estadoactual: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      infocolumna: [],
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
        Departamento: null,
        Ciudad: null,
      },
      items: [
        {
          filtro: "==",
          Descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          Descripcion: "Similar a",
        },
        {
          filtro: ">=",
          Descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          Descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "Responsable",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Responsable del servicio:",
        },
        {
          campo: "Document_ID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Documento:",
        },
        {
          campo: "ContratoID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Contrato:",
        },
        {
          campo: "RefActivo_1",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Activo:",
        },
        {
          campo: "Direccion",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Dirección:",
        },
        {
          campo: "Conjunto",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Conjunto:",
        },
        {
          campo: "IDServicio",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Servicio:",
        },
        {
          campo: "EstadoRevision",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado del Soporte:",
        },
        {
          campo: "InicioMora",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha Inicio Mora:",
        },
        {
          campo: "DiasMora",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Dias Mora:",
        },
        {
          campo: "TipoActivo_ID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo Activo:",
        },
        {
          campo: "SubTipoActivo_ID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Sub Tipo Activo:",
        },
        {
          campo: "Departamento",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Departamento:",
        },
        {
          campo: "Ciudad_ID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Ciudad:",
        },
        {
          campo: "EstadoContrato",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado Contrato:",
        },
        {
          campo: "NovedadContrato",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Novedad Contrato:",
        },
        {
          campo: "EstadoActivo",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado Activo:",
        },
        {
          campo: "EstadoValidacion",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado Validación:",
        },
        {
          campo: "TipoServicio",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo de Servicio:",
        },
      ],
      headers: [],
      desserts: [],
      MPermisosTablero: [],
      PermisoHistorico: "",
      MPermisosFolderDocumentos: [],
      ArrayCiudad_ID: [],
      ArrayDpto_ID: [],
      ArrayEstadoActivo: [],
      ArrayTipoActivo: [],
      ArraySubTipoActivo: [],
      ArrayEstadoSoporte: [],
      ArrayEstadoContrato: [],
      ArrayNovedadContrato: [],
      ArrayTipoServicio: [],
      ArrayServicio: [],
      ArrayIndiceValidar: [],
      ArrayUser: [],
      param1: "",
      param11: "",
      param2: "",
      busquedacompleta: false,
    };
  },
  watch: {
    // Colocar ya que el sistema al ver que la URL ya esta cargada no la vuelve a cargar
    $route: function () {
      this.headers = [];
      this.desserts = [];
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        this.modelfiltro[i].filtro = null;
        this.modelfiltro[i].contenido = null;
      }
      this.parametrospaginas();
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
        if (
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          this.modelfiltro[i].contenido = String(this.modelfiltro[i].contenido);
        }
      }
      this.getConsultaTablero(1, 10);
      this.getPermisosTablero();
      // Consultas a Ejecutar
      //if (!validate) {
      //
      //} else {
      //this.$swal({
      //icon: "warning",
      //title: "Campos Incompletos.",
      //html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
      //});
      //}
    },

    async loadLazy() {
      await this.getConsultaTablero();
    },

    // Consulta Tablero
    async getConsultaTablero(pages, itempages) {
      this.headers = [];
      this.desserts = [];
      this.progreso = true;

      if (pages && itempages) {
        this.itemsPerPage = 10;
        this.page = 1;
      }

      var filtros = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
        parametro1: this.param11,
        tamaniopagina: this.itemsPerPage,
        numeropagina: this.page,
      };

      this.axios
        .post(
          "/controlactivos/CT0/",
          filtros, // El objeto de filtros
          {
            headers: {
              "Content-Type": "application/json", // Importante para que .NET lo interprete correctamente
            },
          },
        )
        .then((result) => {
          this.desserts = result.data;
          if (this.headers.length === 0) {
            this.headers = result.data[0].Cabecera;
          }
          this.totalRecords = result.data[0].CountRegister;
          this.totalPages = Math.ceil(this.totalRecords / this.itemsPerPage);
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    // Get para obtener array de los departamento existentes
    getDpto_ID() {
      this.ArrayDpto_ID = [];
      var ArrayDpto_ID2 = this.$store.getters.MDpto;
      this.ArrayDpto_ID = ArrayDpto_ID2.filter(
        (item) => item.DepartamentoId != 0,
      ).map((item) => ({
        ...item,
        DepartamentoId: item.DepartamentoId.toString(), // o Number(item.Valor) si lo prefieres
      }));
      if (
        this.modelfiltro[12].contenido != "" &&
        this.modelfiltro[12].contenido != null
      ) {
        this.modelfiltro[12].contenido =
          this.modelfiltro[12].contenido.toString();
      }
    },
    // Métpdo de gestion cambio
    ChangeDepto_ID() {
      if (
        this.modelfiltro[12].contenido == "" ||
        this.modelfiltro[12].contenido == null
      ) {
        this.ArrayCiudad_ID = [];
        this.modelfiltro[13].contenido = null;
      } else {
        this.getCiudad_ID();
      }
    },
    // Get para obtener array de las ciudades existentes
    getCiudad_ID() {
      if (
        this.modelfiltro[12].contenido != "" &&
        this.modelfiltro[12].contenido != null
      ) {
        this.ArrayCiudad_ID = [];
        var Dpto = this.modelfiltro[12].contenido;
        var ArrayCiudad_ID2 = this.$store.getters.MCity;
        this.ArrayCiudad_ID = ArrayCiudad_ID2.filter(
          (item) => item.CiudadId != 0 && item.DepartamentoId == Dpto,
        ).map((item) => ({
          ...item,
          CiudadId: item.CiudadId.toString(), // o Number(item.Valor) si lo prefieres
        }));

        if (
          this.modelfiltro[13].contenido != "" &&
          this.modelfiltro[13].contenido != null
        ) {
          this.modelfiltro[13].contenido =
            this.modelfiltro[13].contenido.toString();
        }
      }
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    //Trabajar iconos
    Iconos(infodata, iconoelegido, index) {
      this.dialogframeboton = true;
      this.componenteview = iconoelegido;
      this.infocolumna = infodata;
      this.llaves.TypeDocument_ID = infodata.Columna[2].VC[2];
      this.llaves.Document_ID = infodata.Columna[2].VC[1];
      this.llaves.Primer_Nombre = infodata.Columna[2].VR[0];
      this.llaves.Solicitud = null;
      this.llaves.Contrato = infodata.Columna[1].VC[2];
      this.llaves.Ref_1 = infodata.Columna[1].VC[3];
      this.llaves.Ref_2 = infodata.Columna[1].VR[19];
      this.llaves.Ref_3 = infodata.Columna[1].VR[20];
      this.llaves.Departamento = parseInt(infodata.Columna[1].VR[23]);
      this.llaves.Ciudad = parseInt(infodata.Columna[1].VR[24]);
      if (index != undefined && index != null) {
        this.llaves.IDServicio = infodata.Columna[index].VC[0];
      } else {
        this.llaves.IDServicio = null;
      }
      this.llaves.IDPoliza = null;
      this.llaves.Secuencia_ID = null;
      switch (iconoelegido) {
        case 0: // Riesgos
          this.iconodialogbtn = "mdi-lock-alert";
          this.titledialogbtn = "Riesgos";
          break;
        case 1: // Contratos
          this.iconodialogbtn = "mdi-note";
          this.titledialogbtn = "Contratos";
          break;
        case 2: //Activos
          this.iconodialogbtn = infodata.Columna[1].VC[0];
          this.titledialogbtn = "Activos";
          break;
        case 3: //Seguros
          this.iconodialogbtn = "mdi-file-lock";
          this.titledialogbtn = "Seguros";
          break;
        case 4: //Ubicación
          this.iconodialogbtn = "mdi-map-marker-plus";
          this.titledialogbtn = "Ubicación";
          break;
        case 5: //Cliente
          this.iconodialogbtn = "mdi-account";
          this.titledialogbtn = "Clientes";
          break;
        case 6: //Nueco Contacto
          this.iconodialogbtn = "mdi-account-multiple-plus";
          this.titledialogbtn = "Nuevo Contacto";
          break;
        case 7: //Historicos soportes
          this.iconodialogbtn = "mdi-archive-cog-outline";
          this.titledialogbtn = "Histórico Soportes";
          if (
            this.infocolumna.Columna[1].VR[2] == "Transferido" || // Tranferido
            //this.infocolumna.Columna[1].VR[2] == "Cancelado" || // Cancelado
            this.infocolumna.Columna[1].VR[2] == "Histórico" || // Histórico
            this.infocolumna.Columna[1].VR[2] == "Restituido" || // Restituido
            this.infocolumna.Columna[1].VR[2] ==
              "Transferido proceso de transferencia externo" || // Transferido proceso de transferencia externo
            this.infocolumna.Columna[1].VR[4] == "Restituido" || // Restituido activo
            this.infocolumna.Columna[1].VR[4] == "Transferido" || // Transferido activo
            this.infocolumna.Columna[1].VR[4] == "Histórico" // Histórico activo
          ) {
            this.dialogframeboton = false;
            this.$swal({
              icon: "warning",
              title: "Acceso Inhabilitado.",
              html:
                " Estado del contrato es:  <b>" +
                this.infocolumna.Columna[1].VR[2] +
                "  </b><br>  Estado del activo es: <b>" +
                this.infocolumna.Columna[1].VR[4] +
                " </b><br> Al encontrarse en este estado se deshabilita el acceso a los servicios. ",
            });
          }
          break;
        case 8: //Documentos CLientes
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Documentos CLientes";
          this.llaves.Contrato = null;
          this.llaves.Ref_1 = null;
          this.llaves.IDServicio = null;
          break;
        case 9: //Documentos Contratos
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Documentos Contratos";
          this.llaves.Ref_1 = null;
          this.llaves.IDServicio = null;
          break;
        case 10: //Documentos Activos
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Documentos Activos";
          this.llaves.IDServicio = null;
          break;
        case 11: //Documentos Servicios
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Documentos Servicios";
          break;
        case 12: //ARS
          this.iconodialogbtn = "mdi-account-wrench-outline";
          this.titledialogbtn = "Relación Activo Servicio";
          break;
        case 13: //Trazabilidad
          this.iconodialogbtn = "mdi-history";
          this.titledialogbtn = "Trazabilidad";
          break;
      }
    },
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
      if (this.param2 != null && this.param2 != "") {
        this.modelfiltro[10].filtro = "=";
        this.modelfiltro[10].contenido = this.param2;
        this.modelfiltro[10].clear = false;
        this.modelfiltro[10].lectura = true;
      }
    },
    // Cargar combos de filtros
    CargueCombo() {
      this.ArrayEstadoActivo = this.$store.getters.MTablaSeleccion;

      this.ArrayEstadoActivo = this.ArrayEstadoActivo.filter(
        (item) => item.Valor != null && item.TablaId == 8,
      );

      var EstadoSoporte = this.$store.getters.MTablaSeleccion;
      this.ArrayEstadoSoporte = EstadoSoporte.filter(
        (item) => item.Valor != null && item.TablaId == 10,
      );
      var EstadoContrato = this.$store.getters.MTablaSeleccion;
      this.ArrayEstadoContrato = EstadoContrato.filter(
        (item) => item.Valor != null && item.TablaId == 7,
      );
      var NovedadContrato = this.$store.getters.MTablaSeleccion;
      this.ArrayNovedadContrato = NovedadContrato.filter(
        (item) => item.Valor != null && item.TablaId == 9,
      );

      var TipoServicio = this.$store.getters.MTablaSeleccion;
      this.ArrayTipoServicio = TipoServicio.filter(
        (item) => item.Valor != null && item.TablaId == 57,
      );

      var IndiceValidar = this.$store.getters.MTablaSeleccion;
      this.ArrayIndiceValidar = IndiceValidar.filter(
        (item) => item.Valor != null && item.TablaId == 56,
      );

      var User = this.$store.getters.MUsers;
      this.ArrayUser = User.filter((item) => item.Usuario.includes("TCI"));

      var TipoActivo = this.$store.getters.MTiposActivos;
      this.ArrayTipoActivo = TipoActivo.filter((item) => item.ID != 0);

      // Array Subtipo Activo
      TipoActivo = this.$store.getters.MSubTiposActivos;
      this.ArraySubTipoActivo = TipoActivo.filter((item) => item.ID != 0);

      var Servicio = this.$store.getters.MServicio;
      this.ArrayServicio = Servicio.filter((item) => item.servicioID != 0);
      this.getDpto_ID();
    },

    //Permisos de Tablero
    async getPermisosTablero() {
      var userperfil = this.$store.getters.userperfil.infoperfil;
      var page = this.$store.getters.userperfil.paginainfo;

      this.axios
        .get(
          "/parametros/CD5?Perfil=" +
            userperfil.Perfil_ID +
            "&Pagina=" +
            page.id_link,
        )
        .then((response) => {
          this.MPermisosTablero = response.data;

          // Servicios
          var ArrayServices = this.MPermisosTablero.filter(
            (item) => item.Descripcion == "Servicios Historico",
          );
          this.PermisoHistorico = ArrayServices[0].ParametrosTablero;

          var ArrayServices = this.MPermisosTablero.filter(
            (item) => item.Descripcion == "Botón Documentos",
          );
          this.MPermisosFolderDocumentos =
            ArrayServices[0].ParametrosTablero.split("");
          console.log(this.MPermisosFolderDocumentos);
        })
        .catch((e) => console.log(e));
    },

    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1[0];
        this.param11 = splitparam1;
      }
      if (page.param2 != null && page.param2 != "") {
        this.param2 = parseInt(page.param2);
        this.modelfiltro[10].filtro = "=";
        this.modelfiltro[10].contenido = this.param2;
        this.modelfiltro[10].clear = false;
        this.modelfiltro[10].lectura = true;
      }
    },
  },
  mounted() {
    this.parametrospaginas();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}
button:disabled {
  opacity: 0.5;
}
</style>
